module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_library.js
// module id = 44
// module chunks = 0